import React from 'react';
import {message,Icon} from 'antd';

export function messageTips(tips,type,time) {
    
    message.config({top: '48%',});
    switch(type){
        case 1:    
            message.error({
                duration: time||2,
                maxCount: 1,
                icon:<Icon type="close-circle" />,
                key:type,
                content:tips,
                onClose:()=>{
                    message.destroy();
                }
            });
        break;
        case 2:
            message.warning({
                duration: time||2,
                maxCount: 1,
                icon:<Icon type="exclamation-circle" />,
                key:type,
                content:tips,
                onClose:()=>{
                    message.destroy();
                }
            });  
        break;
        case 3:
            message.success({
                duration: time||2,
                maxCount: 1,
                icon:<Icon type="check-circle" />,
                key:type,
                content:tips,
                onClose:()=>{
                    message.destroy();
                }
            });   
        break;
        default:break;
    }
}

// export function timeFormat(date,type) {
//     let newDate = new Date(date);
//     let year = newDate.getFullYear();
//     let month = newDate.getMonth()+1;
//     if(month<10) {
//         month='0'+month;
//     }
//     let dates = newDate.getDate();
//     if(dates<10) {
//         dates='0'+dates;
//     }
//     let hours = newDate.getHours();
//     if(hours<10) {
//         hours='0'+hours;
//     }
//     let minute = newDate.getMinutes();
//     if(minute<10) {
//         minute='0'+minute;
//     }
//     let seconds = newDate.getSeconds();
//     if(seconds<10) {
//         seconds='0'+seconds;
//     }
//     if(type) {
//         return year+'-'+month+'-'+dates+' '+hours+':'+minute;
//     } else {
//         return year+'-'+month+'-'+dates+' '+hours+':'+minute+':'+seconds;
//     }
// }

export function timeFormat(date) {
    if(!date) {
        return '1970-01-01';
    }
    var arr = date.split("T");
    var d = arr[0];
    var darr = d.split('-');
    var t = arr[1];
    var tarr = t.split('.000');
    var marr = tarr[0].split(':');
    var dd = parseInt(darr[0]) + "/" + parseInt(darr[1]) + "/" + parseInt(darr[2]) + " " + parseInt(marr[0]) + ":" + parseInt(marr[1]) + ":" + parseInt(marr[2]);
    return formatDateTime(dd);
}

function formatDateTime(date) {
    let time = new Date(Date.parse(date));
    let Y = time.getFullYear() + '-';
    let M = addZero(time.getMonth() + 1) + '-';
    let D = addZero(time.getDate()) + ' ';
    let h = addZero(time.getHours()) + ':';
    let m = addZero(time.getMinutes()) + ':';
    let s = addZero(time.getSeconds());
    return Y + M + D + h + m + s;
}

function addZero(num) {
    return num < 10 ? '0' + num : num;
}